//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const discover = angular.module('curalate');

    /**
     * Compatibility functions for ES6 features.
     *
     * Notably: Functions to work with Set/Map which work on IE11/Safari8
     *
     */
  discover.service('ES6ShimService', function() {
    this.setToArray = function(theSet) {
      if (!theSet) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      const items = [];
      theSet.forEach((item) => { items.push(item); });
      return items;
    };

    this.setFromArray = function(items) {
      const s = new Set();
      items.forEach(s.add.bind(s));
      return s;
    };

    this.mapToArray = function(theMap) {
      if (!theMap) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      const items = [];
      theMap.forEach((item, key) => {
        items.push([key, item]);
      });
      return items;
    };

    this.mapValuesToArray = function(theMap) {
      const items = [];
      theMap.forEach((item) => { items.push(item); });
      return items;
    };

    this.mapFromArray = function(items) {
      const m = new Map();
      items.forEach((pair) => {
        m.set(pair[0], pair[1]);
      });
      return m;
    };

    this.copyMap = function(theMap) {
      const m = new Map();
      theMap.forEach((item, key) => {
        m.set(key, item);
      });
      return m;
    };

        //
        // Initialization
        //

        // Use the more performant ES6 variants if available and compliant.
    if (typeof Array.from === 'function') {
      this.setToArray = function(arrayLike) { return Array.from(arrayLike); };
      this.mapToArray = this.setToArray;
      this.mapValuesToArray = function(map) { return Array.from(map.values()); };
    }

        // Check for Set existing so this doesn't kill our phantomJs test environment
    if (window.Set && new Set([1, 2, 3]).size === 3) { // Note: Some browsers (oldSafari) will create a Set of size 1 in this case
      this.setFromArray = function(items) { return new Set(items); };
      this.mapFromArray = function(items) { return new Map(items); };

            // Check for copy constructor support
      if (new Map(new Map([[1, 2], [3, 4]])).size === 2) {
        this.copyMap = function(map) { return new Map(map); };
      }
    }
  });
})();
